<template>
  <v-layout row justify-center class="detalle-pago">
    <v-dialog width="400" v-model="popupActualizarDatos.switchActualizarDatos" class="dialog-pago-efectivo-detalle"
      persistent>
      <v-card class="pago-efectivo-codigo">
        <v-card-title class="card-title">
          <v-container class="container-title">
            <v-layout class="recuerda-pago-efectivo">
              <v-flex>
                <v-img>
                  <img src="./../../../assets/icons/icon-atento-actualizar.svg">
                </v-img>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-title>
        <v-card-text class="card-body">
          <v-container grid-list-md class="text-md-center container-card-body efectivo-card-body">
            <v-layout column class="recuerda-pago-efectivo">
              <v-flex>
                <p class="text-codigo-cip"> {{ `Antes de continuar debes contar con un correo electrónico${popupActualizarDatos.medioDePago == '2' ? ' y celular' : ''}` }}</p>
              </v-flex>
              <v-flex>
                <p>Recuerda que al actualizar tus datos, la respuesta es en 24 horas.</p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row justify-center>
            <v-btn @click="goToUpdateData" class="boton-codigo-pago-efectivo boton-actulizar-datos">Ir a actualizar mis
              datos</v-btn>
          </v-layout>
        </v-card-actions>
        <v-container>
          <v-layout row justify-center>
            <v-flex>
              <p class="link-pago-efectivo text-forma-pago text-forma-pg" @click="closePopup">Volver y utilizar otro
                método de pago</p>
            </v-flex>
          </v-layout>
        </v-container>

      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: [
    'popupActualizarDatos'
  ],
  data: () => ({
  }),
  methods: {
    closePopup () {
      this.$emit('popupActulizarDatosMethod')
    },
    goToUpdateData () {
      this.$router.push('/mi-perfil')
    }
  }
}
</script>

<style scoped>
@import './../../../assets/css/pago-efectivo/codigoPagoEfectivo.css';
</style>



// WEBPACK FOOTER //
// src/components/payment/pago-efectivo/ActualizarDatos.vue